/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Save_FiltersInputs */

const en_common_save_filters = /** @type {(inputs: Common_Save_FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save Filters`)
};

/**
* | output |
* | --- |
* | "Save Filters" |
*
* @param {Common_Save_FiltersInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const common_save_filters = /** @type {((inputs?: Common_Save_FiltersInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Save_FiltersInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_common_save_filters(inputs)
});